import actions from "./actions";
import mutations from "./mutation";
export default {
  namespaced: true,
  state: {
    myVirtualAccounts: [],
    banks: [],
    walletStats: {},
    userWalletInformation: {},
    auditTrailLogs: [],
    auditTrailTotal: 0,
    auditTrailCurrentPage: 1,
    auditTrailPerPage: 10,
    auditTrailSubModule: "",
    auditTrailCauserId: null,
    auditTrailStartDate: "",
    auditTrailEndDate: "",
    auditTrailTableLoading: false,
  },
  actions,
  mutations,
};
